module.exports = __webpack_public_path__ + "img/wx.8b53f3b4.png";